var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-text"},_vm._l((_vm.parsedMessage),function(line,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(line)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }